import { useNode } from '@craftjs/core';
import { Text } from '@descope/page-editor-components';
import React, { useCallback } from 'react';
import { EditorTextSettings } from './EditorErrorMessageSettings';

// eslint-disable-next-line react/require-default-props
type Props = React.ComponentProps<typeof Text> & { 'data-type'?: string };

const EditorErrorMessage = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLElement) => connect(drag(ref)),
		[connect, drag]
	);

	// we want to present the sample error message only on editor and not on the actual page
	// this is why we are passing it as children here and not via craft.props
	return (
		<Text ref={refCb} {...props}>
			{intl.tr('screenEditor.components.errorMessage.placeholder')}
		</Text>
	);
};

EditorErrorMessage.craft = {
	name: 'Error Message',
	props: {
		color: 'error',
		'data-type': 'error-message',
		italic: false,
		typography: 'body1',
		align: 'center' as Props['align'],
		fullWidth: false
	},
	related: {
		settings: EditorTextSettings
	}
};

export { EditorErrorMessage };
